import RosterItem from './RosterItem';
import RosterBooking from './RosterBooking';

export default class RosterSummarizedBooking extends RosterItem {
  constructor(bookings, start, end) {
    super(
      'summarizedbooking',
      start,
      end,
      bookings.every((booking) => booking.hasActuals)
    );
    this.bookings = bookings;
  }

  allHaveActuals() {
    return (
      super.allHaveActuals() && this.bookings.every((booking) => booking.allHaveActuals())
    );
  }

  sort() {
    this.bookings.sort((b1, b2) => b1.start - b2.start);
  }

  addBooking(booking, addSplitSummarizedBookingCallback) {
    // First step: the overlapping summary might not fit for the entire booking, so we need to split off part of the booking
    // IMPORTANT: because we process the bookings in order of start time, this non-overlapping part can only come at the END of the summarized booking's time span
    const newBookings = [];
    const bookingStart = booking.start;
    const bookingEnd = booking.end;

    if (bookingEnd.isAfter(this.end)) {
      const newBooking = new RosterBooking(
        this.end,
        bookingEnd,
        booking.hasActuals,
        booking.fullBookingStart,
        booking.fullBookingEnd,
        booking.booking
      );
      newBookings.push(newBooking);
    }
    // Adding the booking to the summarized booking might result in that we need to split up the current summarized booking
    // Case 1: the start of the booking comes after the start of this summarized booking
    // In this case we split of a new summarized booking from the start of the current one until the start of the booking we are adding
    if (bookingStart.isAfter(this.start)) {
      const oldStart = this.start;
      this.start = bookingStart;
      addSplitSummarizedBookingCallback(
        new RosterSummarizedBooking(this.bookings.slice(), oldStart, bookingStart)
      );
    }
    // Case 2: the end of the booking is before the end of the current summarized booking.
    // In this case we split of a new summarized booking from the end of the booking until the end of the summarized booking
    if (bookingEnd.isBefore(this.end)) {
      const oldEnd = this.end;
      this.end = bookingEnd;
      addSplitSummarizedBookingCallback(
        new RosterSummarizedBooking(this.bookings.slice(), bookingEnd, oldEnd)
      );
    }
    // rather importantly, we add the booking to this summary
    this.bookings.push(booking);
    // The summarized booking has actuals if it already had it and the new booking has actuals too
    this.hasActuals = this.hasActuals && booking.hasActuals;
    return newBookings;
  }
}
